import { Controller } from "@hotwired/stimulus"

// Shell controller for the Vocabulary Flashcard wizard.
//
// Owns cross-step state that isn't tied to a specific step's form —
// currently just the step value (for client-side affordances if needed)
// and the config_id value (for ActionCable subscriptions in the generate
// step).
//
// Individual step behaviors (live preview syncing, generation progress)
// live in their own controllers that are nested inside this one.
export default class extends Controller {
  static values = {
    configId: Number,
    step: String,
  }

  connect() {
    // Reserved for future cross-step concerns (dirty-state warnings,
    // unsaved-changes banners, etc.).
  }
}
